import { render, staticRenderFns } from "./MainLedgerDnevnik.vue?vue&type=template&id=79f5cafe&scoped=true"
import script from "./MainLedgerDnevnik.vue?vue&type=script&lang=js"
export * from "./MainLedgerDnevnik.vue?vue&type=script&lang=js"
import style0 from "./otvoreneStavke.css?vue&type=style&index=0&id=79f5cafe&prod&scoped=true&lang=css&external"
import style1 from "./MainLedgerDnevnik.vue?vue&type=style&index=1&id=79f5cafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5cafe",
  null
  
)

export default component.exports